import { render, staticRenderFns } from "./matchORZOdds.vue?vue&type=template&id=0d0d21bb&lang=pug&"
import script from "./matchORZOdds.vue?vue&type=script&lang=js&"
export * from "./matchORZOdds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports